import { Outlet } from 'react-router-dom';

import styled from '@emotion/styled';

export const SimpleLayout = () => {
  return (
    <Main>
      <Outlet />
    </Main>
  );
};

const Main = styled.main`
  background-color: #f8f9fa;
  /* border: 2px solid red; */
  height: 100vh;
`;
